<template>
    <div id="app-lang-switcher">
        <div class="btn-group">
            <span class="nav-link dropdown-toggle dropdown-toggle-split" data-toggle="dropdown">
                <flag class="flag" v-bind:iso="$t('flag')" />{{ $t('name') | uppercase }}
            </span>

            <div class="dropdown-menu" style="padding: 5px; width: 200px">
                <ul class="lang_list">
                    <li v-for="(lang, i) in this.localeMessages" :key="`Lang${i}`" @click.prevent="setLocale(lang.locale)">
                        <span v-if="lang !== 'en'">
                            <flag class="flag" v-bind:iso="lang.flag" />
                            {{ lang.name | uppercase }}
                        </span>
                        <span v-else>
                            <flag class="flag" iso="gb" />
                            {{ lang.name | uppercase }}
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                localeMessages: this.$i18n.messages
            }
        },

        methods: {
            setLocale(locale) {
                this.$i18n.locale = locale
                this.$router.push({
                    params: {lang: locale}
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/shared/LanguageSwitcher.vue